import company from '../data/company';
import content from '../data/content';
import './ContactBlock.css';

/**
 * Контакты компании. Форм и почтовых сценариев нет — только прямые ссылки.
 */
function ContactBlock() {
  const copy = content.contact;

  return (
    <section className="section section--line" id="contact">
      <div className="container contact">
        <div>
          <h2 className="contact__title">{copy.title}</h2>
          <p className="contact__text">{copy.description}</p>
        </div>

        <div className="contact__list">
          <div className="contact__item">
            <span className="eyebrow">{copy.phoneLabel}</span>
            <a href={company.phoneHref}>{company.phone}</a>
          </div>
          <div className="contact__item">
            <span className="eyebrow">{copy.emailLabel}</span>
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </div>
          <div className="contact__item">
            <span className="eyebrow">{copy.addressLabel}</span>
            <span>{company.address}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactBlock;
